const neighborhoodSingle = {
  displayField: 'name',
  name: 'Neighborhood',
  description: 'Single Neighborhood',
  fields: [
    {
      id: 'name',
      name: 'Name',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'slug',
      name: 'slug',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'id',
      name: 'Neighborhood ID',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'country',
      name: 'Country',
      type: 'Symbol',
      localized: false,
      required: true,
      validations: [ { in: [ 'Other', 'United States', 'Canada' ] } ],
      defaultValue: { 'en-US': 'Other' },
      disabled: false,
      omitted: false
    },
    {
      id: 'googlePlaceId',
      name: 'Google Place ID',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'featuredImg',
      name: 'Featured Image',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'imageWithFocalPoint' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'latlng',
      name: 'Local Logic Coordinates',
      type: 'Location',
      localized: false,
      required: false,
      validations: [],
      disabled: true,
      omitted: false
    }
  ],
  sys: {
    id: 'neighborhoodSingle',
    version: 14,
    updatedAt: '2023-07-14T14:36:17.006Z'
  }
};
export default neighborhoodSingle;